import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { getDependencies } from "../../../entities";

export const FETCH_DATA_ME_DEPENDENCIES_REQUEST = 'FETCH_DATA_ME_DEPENDENCIES_REQUEST';
export const FETCH_DATA_ME_DEPENDENCIES_SUCCESS = 'FETCH_DATA_ME_DEPENDENCIES_SUCCESS';
export const FETCH_DATA_ME_DEPENDENCIES_FAILURE = 'FETCH_DATA_ME_DEPENDENCIES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataMyDependenciesRequest = () => {
    return {
        type: FETCH_DATA_ME_DEPENDENCIES_REQUEST,
    };
};

const fetchDataMyDependenciesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ME_DEPENDENCIES_SUCCESS,
        payload: data
    };
};

const fetchDataMyDependenciesFailure = (error: any) => {
    return {
        type: FETCH_DATA_ME_DEPENDENCIES_FAILURE,
        payload: error,
    };
};

export const getMyDependencies = (userId: string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataMyDependenciesRequest());
        try {
            const response = await getDependencies(userId);
            dispatch(fetchDataMyDependenciesSuccess(response));
        } catch (error: any) {
            dispatch(fetchDataMyDependenciesFailure(error.message));
        }
    };
};
